import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { ArrowDown, Download } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { Button } from '../Button/Button';
import { Card } from '../Card/Card';
import { FileDropzone } from '../FileDropzone/FileDropzone';
import { Column, Row } from '../Layout';
import { Typography } from '../Typography/Typography';
import styles from './CsvStage.module.scss';
import { DropzoneContent } from './DropzoneContent';
const CSV_MIME_TYPES = '.csv,text/csv';
export const GetCsvStageTID = (parentTestId)=>getTestIds(parentTestId);
/**
 * The two-card CSV round trip: download a pre-filled file, then drop the filled-in one back.
 * Copy, schema preview and BI names all arrive as props, so a second stage reuses it unchanged.
 */ export const CsvStage = (param)=>{
    let { texts, schemaPreview, isDownloading, isUploading, uploadDisabled, onDownload, onFileSelected, bi, testId } = param;
    const { CsvStageTestIds: TID } = useMemo(()=>GetCsvStageTID(testId), [
        testId
    ]);
    const renderDropzone = ()=>/*#__PURE__*/ _jsx(DropzoneContent, {
            title: texts.dropzoneTitle,
            hint: texts.dropzoneHint,
            limit: texts.dropzoneLimit,
            isUploading: isUploading,
            testId: TID.Dropzone()
        });
    return /*#__PURE__*/ _jsxs(Column, {
        testId: TID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread({}, bi.downloadCard), {
                skin: "white",
                borderRadius: "ml",
                className: styles.card,
                shadow: "none",
                testId: TID.DownloadCard(),
                children: /*#__PURE__*/ _jsxs(Column, {
                    gap: 12,
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            gap: 14,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Row, {
                                    className: styles.badge,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph2",
                                        skin: "primary",
                                        children: "1"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Row, {
                                    gap: 24,
                                    alignItems: "center",
                                    grow: true,
                                    children: [
                                        /*#__PURE__*/ _jsxs(Column, {
                                            grow: true,
                                            children: [
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "paragraph1",
                                                    weight: "normal",
                                                    children: texts.downloadTitle
                                                }),
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "paragraph2",
                                                    skin: "secondary",
                                                    children: texts.downloadBody
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            className: styles.downloadButton,
                                            skin: "primaryOutline",
                                            size: "small",
                                            suffixIcon: /*#__PURE__*/ _jsx(Download, {}),
                                            loading: isDownloading,
                                            bi: bi.download,
                                            testId: TID.Download(),
                                            onClick: onDownload,
                                            children: texts.downloadButton
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Column, {
                            className: styles.cardBody,
                            children: schemaPreview
                        })
                    ]
                })
            })),
            /*#__PURE__*/ _jsx(Row, {
                className: styles.connectorGap,
                children: /*#__PURE__*/ _jsx(Row, {
                    className: styles.connectorLane,
                    justifyContent: "center",
                    children: /*#__PURE__*/ _jsx(Row, {
                        className: styles.connector,
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ _jsx(ArrowDown, {
                            size: 24
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread({}, bi.uploadCard), {
                skin: "white",
                borderRadius: "ml",
                className: styles.card,
                shadow: "none",
                testId: TID.UploadCard(),
                children: /*#__PURE__*/ _jsxs(Column, {
                    gap: 12,
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            gap: 14,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Row, {
                                    className: styles.badge,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph2",
                                        skin: "primary",
                                        children: "2"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph1",
                                    weight: "normal",
                                    children: texts.uploadTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Column, {
                            className: styles.cardBody,
                            children: /*#__PURE__*/ _jsx(FileDropzone, {
                                accept: CSV_MIME_TYPES,
                                className: styles.dropzone,
                                disabled: isUploading || uploadDisabled,
                                bi: bi.upload,
                                testId: TID.Dropzone(),
                                onFileSelected: onFileSelected,
                                renderContent: renderDropzone
                            })
                        })
                    ]
                })
            }))
        ]
    });
};
